import HelpCenterConfig, { HelpCenterKey } from "../config/helpCenter";

export const generateHelpCenterUrl = (lang: "ja" | "en", key: HelpCenterKey): string => {
  return HelpCenterConfig[key][lang];
};
